export const setActiveRegion = id => {
  return {
    type: 'REGION:SET_ACTIVE',
    payload: { id },
  };
};

export const setActivePage = name => {
  return {
    type: 'PAGE:SET_ACTIVE',
    payload: { name },
  };
};
export const setIsMobile = isMobile => {
  return {
    type: 'SET_IS_MOBILE',
    payload: isMobile,
  };
};

export const setActiveDam = name => {
  return {
    type: 'DAM:SET_ACTIVE',
    payload: { name },
  };
};



// WEBPACK FOOTER //
// ./src/actions/ui.js